module.exports = __webpack_public_path__ + "img/lostConnection.e1d115d2.png";